'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismissTypingIndicator = undefined;

var _isFromBot = require('conversations-schema/pubnub-message/operators/isFromBot');

var _dismissAgentTypingIndicator = require('./dismissAgentTypingIndicator');

var _dismissBotTypingIndicator = require('./dismissBotTypingIndicator');

var dismissTypingIndicator = exports.dismissTypingIndicator = function dismissTypingIndicator(message) {
  return function (dispatch) {
    if ((0, _isFromBot.isFromBot)(message)) {
      dispatch((0, _dismissBotTypingIndicator.dismissBotTypingIndicator)(message));
    } else {
      dispatch((0, _dismissAgentTypingIndicator.dismissAgentTypingIndicator)(message));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/dismissTypingIndicator.js
// module id = 422
// module chunks = 2 3